import { render, staticRenderFns } from "./CustomSvgIcon.vue?vue&type=template&id=cf4afde2&scoped=true&lang=pug"
import script from "./CustomSvgIcon.vue?vue&type=script&lang=js"
export * from "./CustomSvgIcon.vue?vue&type=script&lang=js"
import style0 from "./CustomSvgIcon.vue?vue&type=style&index=0&id=cf4afde2&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf4afde2",
  null
  
)

export default component.exports